module.exports = __webpack_public_path__ + "static/media/Passport-1.fedaf4a3.jpg";